import { useState } from "react";
import { CustomImprovementsModalPanelProps } from "../CustomImprovementSetsModal";
import GenerateSmartTarget from "./GenerateSmartTarget";
import { useRestClientContext } from "../../../contexts/RestClientContext";
import { SmartTargetParams } from "../../../types/types";
import { Message } from "semantic-ui-react";

interface BulkSmartTargetsPanelProps extends CustomImprovementsModalPanelProps {}

export default function BulkSmartTargetsPanel({ teamId, data, onClose, onComplete }: BulkSmartTargetsPanelProps) {
	const [errors, setErrors] = useState<string[]>([]);
	const [loading, setLoading] = useState(false);

	const client = useRestClientContext();

	const onSubmit = (params: SmartTargetParams) => {
		setErrors([]);
		setLoading(true);
		client
			.createMultiPropertySmartTargets(teamId, { ...params, properties: data?.properties })
			.then((response) => {
				response.json().then((json) => {
					setLoading(false);
					onComplete && onComplete(json);
					onClose();
				});
			})
			.catch((err) => {
				setLoading(false);
				const jsonError = err.message.match(/{.*}/);
				if (jsonError) {
					const parsed = JSON.parse(jsonError[0]);
					setErrors(Object.values(parsed));
				} else {
					setErrors(["Error submitting smart target. Check inputs and try again."]);
				}
			});
	};

	return (
		<>
			<GenerateSmartTarget isLoading={loading} onSubmit={onSubmit} />
			{errors.length > 0 && errors.map((error) => <Message error>{error}</Message>)}
		</>
	);
}
